import React, { useRef, useState } from 'react';
import useOnceEffect from '../../../Hooks/useOnceEffect';
import { Avatar } from '../AdminUserPeding'
import '../admin.css';
import useDebounce from '../../../Hooks/useDebounce';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useData } from './useData';
import InfiniteScroll from 'react-infinite-scroll-component';
import useToggle from '../../../Hooks/useToggle';
import ModalEditRole from '../Util/ModalEditRole';
import axios from 'axios';


const AdminUsers = () => {

    const { data, fetch, isFinished, findUser, setIsFinished } = useData()
    const page = useRef(1)
    const history = useHistory();
    const infiniteRef = useRef()
    const [edit, setEdit] = useState()
    const [modal, toggleModal] = useToggle(false)

    const searchUser = useDebounce(
        (_user) => {
            if (_user === "") {
                setIsFinished(false)
                fetch(true, 0)
                return
            }

            findUser(_user)
            return
        },

        []
    )


    const goProfile = (user) => {
        if (!user.profileCompleted) {
            toast.error("Usuario no ha creado perfil", { duration: 3000 })
            return
        }


        localStorage.setItem("userId", user.userId)

        switch (user.roles[0].name) {
            case "ROLE_APPLICANT":
                history.push("/admin/perfil/applicant")
                break;
            case "ROLE_COMPANY":
                history.push("/admin/perfil/company")
                break
            case "ROLE_INSTITUTE":
                history.push("/admin/perfil/formacion")
                break
            default:
                break;
        }
    }

    function editRole(role) {

        toggleModal()
        const { userId } = edit;

        axios
            .put("user/change-role", { userId, role })
            .then(() => {
                toast.success("Rol cambiado");
                let card = document.querySelector(".admin-profile-wrapper")
                card.scrollTop = 0
                window.scrollTo({ top: 0 })
                window.location.reload()
            })
            .catch(() => {
                toast.error("No se pudo cambiar el rol del usuario");
            });

        // edit role
    }
    return (
        <main id="admin" className='user-view mt-3'>

            <div className='form-group border-radius-10 mb-3'>
                <input onChange={({ target }) => searchUser(target.value)} className='form-control' placeholder='&#128270; Buscar Usuario' />
            </div>

            <div className='card card-users' >
                <div className='card-body pt-3'>

                    <InfiniteScroll
                        ref={infiniteRef}
                        dataLength={data.length}
                        next={() => {
                            fetch(true, page.current)
                            page.current = page.current + 1
                        }}

                        hasMore={!isFinished}
                        loader={<h4>Loading...</h4>}
                        scrollableTarget="admin-profile-wrapper"
                    >


                        {data?.map((elm, i) => {
                            return (
                                <section key={i} className="row p-3">

                                    <div className='col-12 col-md-8 col-lg-8'>
                                        <div className='d-flex align-items-center'>
                                            <Avatar name={elm.name} /> &nbsp; {elm.name}
                                        </div>
                                    </div>

                                    <div className='col-12 col-md-4 col-lg-4'>
                                        <div className="d-flex justify-content-between">
                                            <button className="btn-aprove" onClick={() => goProfile(elm)} >
                                                Ver Perfil
                                            </button>
                                            <button className="btn-deny" onClick={() => {
                                                setEdit(elm)
                                                toggleModal()
                                            }}>
                                                Editar Rol <br /> {elm.roles[0]?.description}
                                            </button>
                                        </div>
                                    </div>
                                </section>
                            )
                        })}

                    </InfiniteScroll>
                </div>
            </div>

            <ModalEditRole
                save={editRole}
                show={modal}
                onClose={toggleModal}
                user={edit}
            />
        </main>
    );
};

export default AdminUsers;